import { TuneOutlined } from "@mui/icons-material";
import {
  Button,
  Menu,
  MenuItem,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useState, MouseEvent } from "react";
import { makeSxStyles } from "ui";

type RegionMapFilterProps = {
  onFlatRateChange: (flatRate: boolean) => void;
  onOnDemandChange: (onDemand: boolean) => void;
  onUnassignedOrdersChange: (unassignedOrders: boolean) => void;
  flatRate: boolean | undefined;
  onDemand: boolean | undefined;
  unassignedOrders: boolean | undefined;
};

export const RegionMapFilters: React.FC<RegionMapFilterProps> = ({
  onFlatRateChange,
  onOnDemandChange,
  onUnassignedOrdersChange,
  flatRate,
  onDemand,
  unassignedOrders,
}) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        sx={styles.menuBoxItem}
        aria-label="more"
        id="filter-button"
        className={open ? "menuBoxItemActive" : ""}
        onClick={handleClick}
      >
        <TuneOutlined sx={{ color: "#C1C7CE" }} />
      </Button>
      <Menu
        id="filter-menu"
        MenuListProps={{
          "aria-labelledby": "filter-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className={open ? "onActiveFiltersOpen" : ""}
        sx={styles.filterMenu}
      >
        <MenuItem key="1">
          <FormControlLabel
            value="flatRate"
            control={
              <Switch
                checked={flatRate}
                color="primary"
                onChange={(e) => onFlatRateChange(e.target.checked)}
              />
            }
            label="Flat Rate Customers"
            labelPlacement="start"
          />
        </MenuItem>
        <MenuItem key="2">
          <FormControlLabel
            value="onDemand"
            control={
              <Switch
                checked={onDemand}
                color="primary"
                onChange={(e) => onOnDemandChange(e.target.checked)}
              />
            }
            label="On Demand Customers"
            labelPlacement="start"
          />
        </MenuItem>
        <MenuItem key="3">
          <FormControlLabel
            value="unassignedOrders"
            control={
              <Switch
                checked={unassignedOrders}
                color="primary"
                onChange={(e) => onUnassignedOrdersChange(e.target.checked)}
              />
            }
            label="Unassigned Orders"
            labelPlacement="start"
          />
        </MenuItem>
      </Menu>
    </>
  );
};

const useStyles = makeSxStyles(() => ({
  menuBoxItem: {
    width: "36px",
    height: "36px",
    minWidth: "unset",
    padding: "unset",
    borderRadius: "100%",

    "&.menuBoxItemActive": {
      textDecoration: "none",
      backgroundColor: "rgba(144, 202, 249, 0.08) !important",
    },
  },
  filterMenu: {
    "& .MuiMenu-list": {
      backgroundColor: "#1A1C1E",
      minWidth: "300px",
    },
    "& .MuiMenu-list > li label": {
      marginLeft: "0",
      width: "100%",
      justifyContent: "space-between",
    },
  },
}));
